import { useEffect } from 'react';
import BrowserCookies from '~/utilities/BrowserCookies';
import { NEW_CARS_HERO_SUPPRESSED_COOKIE } from '~/utilities/new-cars/newCarsFlowLevel';

export default function useSuppressHeroFromPromo(
  arrivedFromPromo: boolean
): void {
  useEffect(() => {
    if (arrivedFromPromo) {
      BrowserCookies.set(NEW_CARS_HERO_SUPPRESSED_COOKIE, '1', {
        path: '/new'
      });
    }
  }, [arrivedFromPromo]);
}
